import {
  IPermissionByRole,
  IPermissionsBySection,
} from 'interfaces/permissions';

const roleNotFoundPermissions: IPermissionsBySection = {
  user: {
    canCreate: false,
    canRead: false,
    canReadDetails: false,
    canUpdate: false,
  },
  europeAssistanceIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
  b2bIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
};

const magicAdminPermissions: IPermissionsBySection = {
  b2bIntervention: {
    canCreate: true,
    canRead: true,
    canUpdate: true,
  },
  europeAssistanceIntervention: {
    canCreate: true,
    canRead: true,
    canUpdate: true,
  },
  user: {
    canCreate: true,
    canRead: true,
    canReadDetails: true,
    canUpdate: true,
  },
};
const superAdminPermissions: IPermissionsBySection = {
  b2bIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
  europeAssistanceIntervention: {
    canCreate: true,
    canRead: true,
    canUpdate: true,
  },
  user: {
    canCreate: true,
    canRead: true,
    canReadDetails: true,
    canUpdate: true,
  },
};

const userManagerPermissions: IPermissionsBySection = {
  europeAssistanceIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
  b2bIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
  user: {
    canCreate: true,
    canRead: true,
    canReadDetails: true,
    canUpdate: true,
  },
};

const interventionHandlerPermissions: IPermissionsBySection = {
  europeAssistanceIntervention: {
    canCreate: true,
    canRead: true,
    canUpdate: true,
  },
  b2bIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
  user: {
    canCreate: false,
    canRead: false,
    canReadDetails: true,
    canUpdate: false,
  },
};
const b2bApplyerPermissions: IPermissionsBySection = {
  europeAssistanceIntervention: {
    canCreate: false,
    canRead: false,
    canUpdate: false,
  },
  b2bIntervention: {
    canCreate: true,
    canRead: true,
    canUpdate: false,
  },
  user: {
    canCreate: false,
    canRead: false,
    canReadDetails: true,
    canUpdate: false,
  },
};

export const permissions: IPermissionByRole = {
  magic_admin: magicAdminPermissions,
  super_admin: superAdminPermissions,
  intervention_handler: interventionHandlerPermissions,
  user_manager: userManagerPermissions,
  not_found: roleNotFoundPermissions,
  b2b_applyer: b2bApplyerPermissions,
};
